export class SobreprimasModel {

  ses_Sobre_Prima: string;
  id_Sobre_Prima: number;
  pct_Sobre_Prima: number;

  constructor( obj: {
    Des_Sobre_Prima: string;
    Id_Sobre_Prima: number;
    Pct_Sobre_Prima: number;
  } ) {
    this.ses_Sobre_Prima = obj.Des_Sobre_Prima;
    this.id_Sobre_Prima = obj.Id_Sobre_Prima;
    this.pct_Sobre_Prima = obj.Pct_Sobre_Prima;
  }
}
